export default "__VITE_ASSET__06d4b57f__"